
const ProjectModel = {

  "MakerWeek": {
    caseStudy: true,
    splitScreen: true,
    shape: "makerweek",
    title: "Maker Week",
    client: "Figma",
    category: "3D",
    pageUrl: "/maker-week",
    imageUrl: "img/homepage/MariaChimishkyan-Figma-MakerWeek.gif",
    altDescription: "Maker Week by Figma",
    thumbnailUrl: "img/project-index/MariaChimishkyan-Figma-MW.jpg",
    rolloverColor: "#24cb71",
    headline: "Identity for Figma's 2024 Maker Week, an annual internal hackathon. The system draws from imperfect, handmade construction and open outdoor spaces. Things that carry a sense of freedom and permission to try without overthinking it.",
    projectName: "Maker Week",
    articleLink: "",
    discipline: "Visual Identity, Motion Design, Photography",
    contributors: [
    { role: "Brand Designer", name: "Chelsea White", link: "" },
    { role: "Copywriter", name: "Kaley Aposporos", link: "" },
    { role: "Producer", name: "Sydney Halle", link: "" },
	],
    timeline: "2025",
    deliverables: ["3D Animation", "Motion Design"],
  },

  "ShapeOfSense": {
    caseStudy: true,
    splitScreen: true,
    shape: "google-tsos",
    title: "The Shape of Sense",
    client: "Google",
    category: "3D",
    pageUrl: "/shape-of-sense",
    imageUrl: "img/homepage/29-MariaChimishkyan-Google-TSOS.gif",
    altDescription: "",
    thumbnailUrl: "img/project-index/MariaChimishkyan-Google-TheShapeofSense.jpg",
    rolloverColor: "#C4B5F4",
    headline: "Identity for a remote summit within Google's UX research organization. The work explored what it means to gather when you're not in the same room — how presence, attention, and shared experience operate differently at a distance.",
    projectName: "The Shape of Sense",
    articleLink: "",
    discipline: "Visual Identity, Motion Design, Swag Design",
    contributors: [
    { role: "Creative Lead", name: "Megan Lynch", link: "https://megan-lynch.com/" }, 
    { role: "Brand Designer", name: "Ingrid Ma", link: "" }, 

	],
    timeline: "2025",
    deliverables: ["3D Animation", "Motion Design", "Identity"],
  },

  "Config2025": {
    caseStudy: true,
    splitScreen: true,
    shape: "config2025",
    title: "Config 2025",
    client: "Figma",
    category: "3D",
    pageUrl: "/config-2025",
    imageUrl: "img/homepage/MariaChimishkyan-Figma-Config25-3.jpg",
    altDescription: "",
    thumbnailUrl: "img/project-index/MariaChimishkyan-Figma-Config25.jpg",
    rolloverColor: "#00B6FF",
    headline: "A system that reflects how design moves. Not linearly, but through twists and turns, collisions, and sudden shifts that end up somewhere better than planned.",
    projectName: "Config 2025",
    articleLink: "",
    discipline: "Visual Identity, Experiential Design",
    contributors: [],
    contributorGroups: [
      {
        label: "Core Team",
        members: [
          { role: "Creative Director", name: "Damien Correll", link: "https://www.instagram.com/damiencorrell/" },
          { role: "Creative Lead", name: "Leandro Castelao", link: "https://castelao.works/" },
          { role: "Brand Designer", name: "Chelsea White", link: "https://www.instagram.com/chelsea_lane_white/" },
          { role: "Producer", name: "Sydney Halle" },
          { role: "Motion Design Lead", name: "Chad Colby" },
          { role: "Motion Designer", name: "Gilles Desmadrille", link: "https://gillesdesmadrille.com/}"},
          { role: "Motion Designer", name: "Ben Hill", link: "https://benjamin-hill.com/}"},
          { role: "Web Design Lead", name: "Catherine Bui", link: "https://catherinebui.com/" },
          { role: "Web Designer", name: "Andy Luce", link: "" },
          { role: "Copywriter", name: "Kaley Aposporos", link: "" },
        ],
      },
	  {
        label: "With",
        members: [
          { role: "Events team at Figma"},
          { name: "Acronym", link: "https://acronym.lol/"},
          { name: "Sounds Like These", link: "https://soundslikethese.com/"}
        ],
      },
      {
        label: "Contributors",
        members: [
		  { role: "Producer", name: "Mika Kunisaki", link: "" },
		  { role: "Brand Designer", name: "Jessica Svendsen", link: "" },
      { role: "Web Designer", name: "Brian Swarthout", link: "https://www.brianswarthout.com/" },
      { role: "Copywriter", name: "Carly Ayres", link: "https://substack.com/@carly" },


        ],
      },
      {
        label: "Type by",
        members: [
          {name: "Grilli Type", link: "https://www.grillitype.com/" },
        ],
      },
    ],
    timeline: "2025",
    deliverables: ["Visual Identity", "Spatial Design"],
  },

  "AdidasStateSneakers": {
    title:"State Sneakers",
    client:"Adidas",
    category:"Illustration",
    pageUrl:"/adidas-statesneakers",
    imageUrl:"img/homepage/MariaChimishkyan-adidas.jpg",
    altDescription:"Illustration",
    thumbnailUrl:"img/project-index/maria_chimishkyan_adidas_state_sneakers.jpg",
	rolloverColor:"#9d5f48",
    	headline:"Package of illustrations and patterns depicting the most popular Adidas sneakers in every state. A celebratory mood comes together through sprinkled outlines of states, soft symbols representative of different locales, and lively gestural glimmers. ",
		projectName:"State Sneakers",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Nico Mattison",
		contributorLink:"TK",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 	
	

  
   "Apple": {
    title:"Best Podcasts of 2021",
    client:"Apple",
    category:"Animation · Illustration",
    pageUrl:"/apple",
    imageUrl:"img/homepage/MariaChimishkyan-Apple.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Apple.jpg",
	rolloverColor:"#FF78A6",
    	headline:"A campaign package celebrating Apple's end of year selection of best podcasts in 2021.",
		projectName:"Best of 2021",
		articleLink:"https://www.apple.com/newsroom/2021/11/apple-podcasts-presents-the-best-of-2021/",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Dora Godfrey",
		contributorLink:"http://doragodfrey.info/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
   "AppleArtText": {
    title:"Art Text",
    client:"Apple",
    category:"Animation",
    pageUrl:"/apple-art-text",
    imageUrl:"img/homepage/MariaChimishkyan-Apple-ArtText.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/maria_chimishkyan_apple_art_text.jpg",
	rolloverColor:"#a47cbd",
    	headline:"Editorial illustration for the App Store showcasing the spirit of Art Text, an app that brings text to life.",
		projectName:"Art Text",
		articleLink:"",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Lynnette Galloway",
		contributorLink:"",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  
    "Atlantic": {
    title:"Best of 2021",
    client:"The Atlantic",
    category:"Animation · Illustration",
    pageUrl:"/atlantic",
    imageUrl:"img/homepage/MariaChimishkyan-the-atlantic.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-The-Atlantic.jpg",
	rolloverColor:"#085C34",
    	headline:"A series of animated editorial illustrations to accompany the featured categories of an end of year roundup.",
		projectName:"Best of 2021",
		articleLink:"https://www.theatlantic.com/best-2021-movies-tv-albums-books-podcasts/",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Adam Maida",
		contributorLink:"https://adammaida.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 	
  
  
	"Bandcamp": {
    title: "Music for Plants",
    client:"Bandcamp",
    category:"Animation · Illustration",
    pageUrl:"/bandcamp",
    imageUrl:"img/homepage/MariaChimishkyan-Bandcamp.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bandcamp.gif",
	rolloverColor:"#ffed4a",
    	headline:"A series of animated illustrations for Bandcamp's Music For Plants, an article exploring the different emotional responses of plants to music.",
		projectName:'"Music for Plants"',
		articleLink:"https://daily.bandcamp.com/lists/music-for-plants",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Nicole Ginelli",
		contributorLink:"http://www.nicoleginelli.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   
  
  "BandcampExperimental": {
    title: "Five Records Made With Invented Instruments",
    client:"Bandcamp",
    category:"Animation · Illustration",
    pageUrl:"/bandcamp_experimental",
    imageUrl:"img/homepage/MariaChimishkyan-Bandcamp_Experimental.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bandcamp-Experimental.jpg",
	rolloverColor:"#535B73",
    	headline:"Depicting the DIY nature of experimental instruments and the different materials & techniques involved in their creation.",
		projectName:"Five Records Made With Invented Instruments",
		articleLink:"https://daily.bandcamp.com/lists/invented-instruments-list",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Josie Keefe",
		contributorLink:"https://josiekeefe.net/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   
  
  
  
  
	"BloombergBusinessweekAvon": {
    title: "Misc. Illustrations",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweek.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-BloombergBusinessweek.gif",
	rolloverColor:"#f8694c",
    	headline:"",
		projectName:"Avon is Trying to Give Itself a Makeover",
		articleLink:"https://www.bloomberg.com/news/articles/2018-07-18/avon-is-trying-to-give-itself-a-makeover",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Chandra Illick",
		contributorLink:"http://www.chandraillick.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   
  
  
	"BloombergBusinessweekLuxury": {
    title: "",
    client:"Bloomberg Businessweek",
    category:"",
    pageUrl:"",
    imageUrl:"",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"",
    	headline:"",
		projectName:"Europe’s Biggest Luxury Brands Are Nervous About China",
		articleLink:"https://www.bloomberg.com/news/articles/2018-10-18/europe-s-biggest-luxury-brands-are-nervous-about-china",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Chandra Illick",
		contributorLink:"http://www.chandraillick.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   
  
  
	"BloombergBusinessweekApps": {
    title: "",
    client:"Bloomberg Businessweek",
    category:"",
    pageUrl:"",
    imageUrl:"",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"",
    	headline:"",
		projectName:'"Apps Are Coming for Your Happy Hour"',
		articleLink:"https://www.bloomberg.com/news/articles/2018-05-23/apps-are-coming-for-your-happy-hour",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Chandra Illick",
		contributorLink:"http://www.chandraillick.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   
  
  
	"BloombergBusinessweekGoogle": {
    title: "",
    client:"Bloomberg Businessweek",
    category:"",
    pageUrl:"",
    imageUrl:"",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"",
    	headline:"",
		projectName:"Google Is Training Machines to Predict When a Patient Will Die",
		articleLink:"https://www.bloomberg.com/news/articles/2018-06-18/google-is-training-machines-to-predict-when-a-patient-will-die",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Steph Davidson",
		contributorLink:"https://paralleluniver.se/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
  
  
	"BloombergBusinessweekSpotify": {
    title: "Spotify Bets Big on Podcasts as a Path to Profitability",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweek.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-BloombergBusinessweek.gif",
	rolloverColor:"#845477",
    	headline:"",
		projectName:'"Spotify Bets Big on Podcasts as a Path to Profitability"',
		articleLink:"https://www.bloomberg.com/news/features/2021-01-12/spotify-spot-views-joe-rogan-more-podcasts-as-path-to-profitability",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Alexander Shoukas",
		contributorLink:"http://alexandershoukas.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },    
  
  "BloombergBusinessweekMisc": {
    title: "Misc. Illustrations",
    client: "Bloomberg Businessweek",
    category: "Illustration",
    pageUrl: "/bloomberg-businessweek",
    imageUrl: "",
    altDescription: "",
    thumbnailUrl: "",
    rolloverColor: "",
    headline: "Miscellaneous editorial illustrations completed for Bloomberg Businessweek over the years, online and in print.",
    projectName: "Misc. Illustrations",
    articleLink: "",
    discipline: "Illustration",
    contributorRole: "",
    contributorName: "",
    contributorLink: "",
    contributorRole1: "",
    contributorName1: "",
    contributorLink1: "",
  },

    "BloombergBusinessweekJunk": {
    title: "Titans of Junk",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweek-TitansofJunk.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-BloombergBusinessweek.gif",
	rolloverColor:"#685F63",
    	headline:"Illustrations completed for Bloomberg Businessweek over the years, online and in print.",
		projectName:'"Titans of Junk"',
		articleLink:"https://www.bloomberg.com/news/articles/2022-02-03/netflix-tesla-t-mobile-and-dell-turned-junk-debt-into-bond-market-treasure",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Chandra Illick",
		contributorLink:"http://www.chandraillick.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
  
  
    "BloombergBusinessweekData": {
    title: "The Dangers of the Data Trade",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweek-DataBrokers.png",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-BloombergBusinessweek.gif",
	rolloverColor:"#B87CB7",
    	headline:"",
		projectName:"The Dangers of the Data Trade",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Saxton Randolph",
		contributorLink:"",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
  
    "BloombergBusinessweekRealEstate": {
    title: "Real Estate Recovery?",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek",
    imageUrl:"img/homepage/MariaChimishkyan-Bloomberg.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-BloombergBusinessweek.gif",
	rolloverColor:"#B87CB7",
    	headline:"",
		projectName:'"Real Estate Recovery?"',
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Jordi Ng",
		contributorLink:"https://awpoop.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
   
    
	"BloombergBusinessweekCover": {
    title: "Are We There Yet?",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek-cover",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweekCover.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bloomberg-Businessweek.jpg",
	rolloverColor:"#7E6257",
    	headline:"Cover illustration and inside spread for the November 2nd issue of Bloomberg Businessweek, spotlighting Operation Warp Speed's sprint towards a viable vaccine.",
		projectName:"Are We There Yet?",
		articleLink:"https://www.bloomberg.com/magazine/businessweek/20_46",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Alexander Shoukas",
		contributorLink:"http://alexandershoukas.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 

	"BloombergBusinessweekCurrencies": {
    title: "Can't Stop Won't Stop",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek-currencies",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweekCurrencies.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bloomberg-Businessweek.jpg",
	rolloverColor:"#353336",
    	headline:"Cover illustration for the October 3rd issue of Bloomberg Businessweek spotlighting the collapse of the Euro, Pound & Yen amid the surge of the dollar.",
		projectName:"Cant Stop Wont Stop",
		articleLink:"https://www.bloomberg.com/magazine/businessweek/22_42",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Chandra Illick",
		contributorLink:"chandraillick.com",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  
  

	"BloombergBusinessweekFeature": {
    title: "Inside Operation Warp Speed’s $18 Billion Sprint for a Vaccine",
    client:"Bloomberg Businessweek",
    category:"Illustration",
    pageUrl:"/bloomberg-businessweek-cover",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergBusinessweekCover.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-BloombergBusinessweek.gif",
	rolloverColor:"#92c2b9",
    	headline:"",
		projectName:"Inside Operation Warp Speed’s $18 Billion Sprint for a Vaccine",
		articleLink:"https://www.bloomberg.com/news/features/2020-10-29/inside-operation-warp-speed-s-18-billion-sprint-for-a-vaccine",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Alexander Shoukas",
		contributorLink:"http://alexandershoukas.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },
  
 	"BloombergGreen": {
    title: "The Tech Tracking Down Methane Leaks",
    client:"Bloomberg Green",
    category:"Illustration",
    pageUrl:"/bloomberg-green",
    imageUrl:"img/homepage/MariaChimishkyan-BloombergGreen.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bloomberg-Green.jpg",
	rolloverColor:"#ac5d7c",
    	headline:"Series of spot illustrations showcasing the various methods and devices used to track methane leaks.",
		projectName:"The Tech Tracking Down Methane Leaks",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Erin Knutson",
		contributorLink:"http://www.erinknutson.studio/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },
  

  
  
  "Bushwig2019": {
    title: "Berlin & NY 2019",
    client:"Bushwig",
    category:"Event Identity",
    pageUrl:"/bushwig-2019",
    imageUrl:"img/homepage/MariaChimishkyan-Bushwig2019.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bushwig2019.png",
	rolloverColor:"#ff2b1c",
    	headline:"Identity, posters and misc. social assets for Bushwig NYC 2019.",
		projectName:"Berlin & NY 2019",
		articleLink:"",
		discipline:"Illustration & Animator",
		contributorRole:"",
		contributorName:"",
		contributorLink:"",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },

  
  "Bushwig2018": {
    title: "Bushwig 2018",
    client:"Bushwig",
    category:"Animation · Event Identity · Illustration",
    pageUrl:"/Bushwig-2018",
    imageUrl:"img/homepage/MariaChimishkyan-Bushwig-2018.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Bushwig-2018.gif",
	rolloverColor:"#ffe436",
    	headline:"Identity, posters and misc. social assets for Bushwig NYC 2018.",
		projectName:"Bushwig 2018",
		articleLink:"",
		discipline:"Illustration & Animator",
		contributorRole:"",
		contributorName:"",
		contributorLink:"",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
   
 
  
  "CashApp": {
    title: "Treasure Hunt",
    client:"Cash App",
    category:"Illustration",
    pageUrl:"/cash-app-ISpy",
    imageUrl:"img/homepage/MariaChimishkyan-CashApp.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-CashApp.jpg",
	rolloverColor:"#c2e942",
    	headline:"A treasure hunt with an accompanying caption: Three ball point pens, a loosened necktie, three blue dollar signs, one eight sided die. Two weighted barbells, some coins stacked up high, and when you've found those it's over, you've done it, goodbye.",
		projectName:"Treasure Hunt",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Claire Merchlinsky",
		contributorLink:"https://clairemerchlinsky.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 

  "CashAppCashTruths": {
    title: "Cash Truths",
    client:"Cash App",
    category:"Animation",
    pageUrl:"/cash-app-cash-truths",
    imageUrl:"img/homepage/MariaChimishkyan-CashApp-CashTruths.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-CashApp-CashTruths.jpg",
	rolloverColor:"#283dc3",
    	headline:"Ambient animations accompanying meditations on cash.",
		projectName:"Cash Truths",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Claire Merchlinsky",
		contributorLink:"https://clairemerchlinsky.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  
 
  
   

  "Elsewhere": {
    title: "Misc. Animations",
    client:"Elsewhere",
    category:"Animation",
    pageUrl:"/elsewhere",
    imageUrl:"img/homepage/MariaChimishkyan-Elsewhere.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Elsewhere.gif",
	rolloverColor:"#ff7bdc",
    	headline:"Abstract animations created to promote various events at Elsewhere.",
		projectName:"Misc. Animations",
		articleLink:"",
		discipline:"Animation",
		contributorRole:"Art Direction",
		contributorName:"Eye Bodega",
		contributorLink:"",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  

  
  "HighSnobiety": {
    title: "The Plastic Surgery Paradigm",
    client:"High Snobiety",
    category:"Illustration",
    pageUrl:"/high-snobiety",
    imageUrl:"img/homepage/MariaChimishkyan-HighSnobiety-PlasticSurgery.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-HighSnobiety-PlasticSurgery.jpg",
	rolloverColor:"#233A2B",
    	headline:"A bag spill of various accessories, jewelry, and plastic surgery tools among other things. The casual mix of these disparate items underscores the growing ubiquity of plastic surgery in the lives of younger generations. This piece appeared in print and online in the summer 2023 issue of The High Snobiety Magazine.",
		projectName:"The Plastic Surgery Paradigm",
		articleLink:"https://www.highsnobiety.com/p/gen-z-plastic-surgery-cosmetic-procedures/",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Matteo Mobilio",
		contributorLink:"http://www.matteomobilio.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
  
 
  "LATimesClimateChange": {
    title: "Finding clean air in Los Angeles? It’s an almost unsolvable puzzle.",
    client:"LA Times",
    category:"Illustration",
    pageUrl:"/latimes-climatechange",
    imageUrl:"img/homepage/MariaChimishkyan-LATimes.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-LATimes.jpg",
	rolloverColor:"#F7E167",
    	headline:"A jumbled puzzle of iconic Los Angeles motifs shifting around in space. The confusion of these interlocking pieces visually reflects the challenge of finding clean air in the city.",
		projectName:"Finding clean air in Los Angeles? It’s an almost unsolvable puzzle.",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Allison Hong",
		contributorLink:"https://allimyhdesign.tumblr.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   

 
  
   "LuxMagazine": {
    title: "Consciousness Raising with Corporations",
    client:"Lux Magazine",
    category:"Illustration",
    pageUrl:"/lux-magazine",
    imageUrl:"img/homepage/MariaChimishkyan-LuxMagazine.jpg",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"#213468",
    	headline:"Accompanying illustration for a piece about the bizarre world of corporate feminism.",
		projectName:"Consciousness Raising with Corporations",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Sharanya Durvasula",
		contributorLink:"",
		
		contributorRole1:"Editorial Design",
		contributorName1:"Chloe Scheffe",
		contributorLink1:"https://chloescheffe.github.io/"
  },  
 
 
  
  "Medium": {
    title: "Misc. Illustrations",
    client:"Medium",
    category:"Illustration",
    pageUrl:"/medium",
    imageUrl:"img/homepage/MariaChimishkyan-Medium.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Medium.gif",
	rolloverColor:"#ffffff",
    	headline:"Misc. editorial illustrations for Medium articles & columns.",
		projectName:"Designers are imagining video games without guns",
		articleLink:"https://onezero.medium.com/its-time-to-take-the-guns-out-of-video-games-10c7e01869e5",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Noah Baker",
		contributorLink:"https://noahbaker.work/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },


  "Medium1": {
    title: "",
    client:"Medium",
    category:"",
    pageUrl:"",
    imageUrl:"",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"",
    	headline:"",
		projectName:"Carbo-Loading is Dead. Long Live Carbs!",
		articleLink:"https://elemental.medium.com/is-carbo-loading-still-a-thing-7e1f9e357d84",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Dora Godfrey",
		contributorLink:"http://doragodfrey.info/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },


  "Medium2": {
    title: "",
    client:"Medium",
    category:"",
    pageUrl:"",
    imageUrl:"",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"",
    	headline:"",
		projectName:"The Future of Fertility",
		articleLink:"https://onezero.medium.com/at-the-fringes-of-fertility-tech-2d3bb749bc65",
		discipline:"Illustration",
		contributorRole:"Editorial design & art direction",
		contributorName:"Ryan Hubbard",
		contributorLink:"http://ryanjhubbard.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },
  
   
  "Medium3": {
    title: "",
    client:"Medium",
    category:"",
    pageUrl:"",
    imageUrl:"",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"",
    	headline:"",
		projectName:"Future Humans",
		articleLink:"https://onezero.medium.com/will-humanity-be-better-off-in-2118-d1b2b44cd998",
		discipline:"Illustration",
		contributorRole:"Editorial design & art direction",
		contributorName:"Ryan Hubbard",
		contributorLink:"http://ryanjhubbard.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  

  
  "NewYorker": {
    title:"The Obsessive Pleasures of Mechanical-Keyboard Tinkerers",
    client:"The New Yorker",
    category:"Animation · Illustration",
    pageUrl:"/newyorker",
    imageUrl:"img/homepage/MariaChimishkyan-the-new-yorker.gif",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"#facc6a",
    	headline:"Exploring the impressive customizations and flights of fancy that mechanical keyboards offer.",
		projectName:"The Obsessive Pleasures of Mechanical-Keyboard Tinkerers",
		articleLink:"https://www.newyorker.com/tech/annals-of-technology/the-obsessive-pleasures-of-mechanical-keyboard-tinkerers",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Nicholas Konrad",
		contributorLink:"https://www.nicholaskonrad.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  
  
  "NewYorker_BitterPill": {
    title:"Bitter Pill",
    client:"The New Yorker",
    category:"Animation · Illustration",
    pageUrl:"/newyorker-bitter-pill",
    imageUrl:"img/homepage/MariaChimishkyan-TheNewYorker-BitterPill.jpg",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"#487b8e",
    	headline:"For an article about patient-advocacy groups that mobilized to expedite access to Relyvrio, a powdered drug designed for ALS treatment. The piece sheds light on the broader consequences of hasty FDA approvals. Published in the print edition of the June 26, 2023 issue of the New Yorker.",
		projectName:"Bitter Pill",
		articleLink:"https://www.newyorker.com/magazine/2023/06/26/relyvrio-als-fda-approval",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Nicholas Blechman",
		contributorLink:"https://www.nicholasblechman.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
      
  
  
  "NewYorker_MDMA": {
    title:"MDMA Research",
    client:"The New Yorker",
    category:"Animation · Illustration",
    pageUrl:"/newyorker-mdma",
    imageUrl:"img/homepage/MariaChimishkyan-TheNewYorker-MDMA.jpg",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"#38302D",
    	headline:"Exploring MDMA research, and the different environments and moods in which MDMA makes an appearance these days.",
		projectName:'"MDMA Research"',
		articleLink:"TK",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Nicholas Konrad",
		contributorLink:"https://www.nicholaskonrad.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
    
  
  
  "Nike": {
    title:"Birthday Animation",
    client:"Nike",
    category:"Animation · Illustration",
    pageUrl:"/nike",
    imageUrl:"img/homepage/MariaChimishkyan-Nike.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Nike.jpg",
	rolloverColor:"#fffd3e",
    	headline:"Celebratory birthday animations with surprise twists for online channels & in-store.",
		projectName:"Birthday Animation",
		articleLink:"",
		discipline:"Animation",
		contributorRole:"Creative Direction",
		contributorName:"Anyways Creative",
		contributorLink:"https://www.anyways.co/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
  
  
  "NYTimes": {
    title:"When Gamers Become Parents, Finding Balance is Next Level",
    client:"The New York Times",
    category:"Animation · Illustration",
    description:"When Gamers Become Parents",
    pageUrl:"/nytimes",
    imageUrl:"img/homepage/MariaChimishkyan-NYTimes.gif",
    altDescription:"When Gamers Become Parents.",
    thumbnailUrl:"img/project-index/MariaChimishkyan-NYTimes.gif",
    rolloverColor:"#ec5929",
    	headline:"Depicting a balance of activities for parents who continue to be gamers after having children.",
		projectName:"When Gamers Become Parents, Finding Balance is Next Level",
		articleLink:"https://www.nytimes.com/2020/04/17/parenting/video-games-parents.html",
		discipline:"Illustration, Animation",
		contributorRole:"Art Direction",
		contributorName:"Deanna Donegan",
		contributorLink:"http://www.deannadonegan.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
   
   
  "NYTimesRightToBeauty": {
    title:"In Brazil, Beauty Is a Right. Are They On to Something?",
    client:"The New York Times",
    category:"Illustration",
    description:"In Brazil, Beauty Is a Right. Are They On to Something?",
    pageUrl:"/nytimes-right-to-beauty",
    imageUrl:"img/homepage/MariaChimishkyan-nytimes-RightToBeauty.jpg",
    altDescription:"In Brazil, Beauty Is a Right. Are They On to Something?",
    thumbnailUrl:"img/project-index/MariaChimishkyan-nytimes-RightToBeauty.jpg",
    rolloverColor:"#565d53",
    	headline:"For an essay detailing an experience with plastic surgery outside of the US. The piece explores the power that comes with controlling one’s appearance.",
		projectName:"In Brazil, Beauty Is a Right. Are They On to Something?",
		articleLink:"https://www.nytimes.com/2023/07/15/opinion/do-we-have-a-right-to-beauty.html",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Shoshana Schultz",
		contributorLink:"https://shoshanaschultz.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
     
   
   
  "RBMA": {
    title:"Educational Modules",
    client:"Red Bull Music Academy",
    category:"Animation · Illustration",
    pageUrl:"/rbma",
    imageUrl:"img/homepage/MariaChimishkyan-rbma.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-rbma.png",
	rolloverColor:"#ff9ad3",
    	headline:"Animated weekly illustrations for Red Bull Music Academy’s Educational Modules.",
		projectName:"Educational Modules",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Creative Direction",
		contributorName:"Johannes Ammler",
		contributorLink:"http://www.johannesammler.de/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""

  },  
   


  "SpaceNinety8": {
    title:"Space Ninety 8",
    client:"Urban Outfitters",
    category:"Art Direction · Stop Motion",
    pageUrl:"/uo-space-ninety-8",
    imageUrl:"img/homepage/MariaChimishkyan-UO-SpaceNinety8.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-UO-SpaceNinety8.gif",
	rolloverColor:"#B3B9CC",
    	headline:"Stop motion compositions celebrating the construction of Urban Outfitters Space Ninety 8 in Williamsburg & building up excitement for its opening day.",
		projectName:"Space Ninety 8",
		articleLink:"",
		discipline:"Designer",
		contributorRole:"Art Direction",
		contributorName:"Namik Schwarz",
		contributorLink:"https://namiks.tumblr.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 
     
  
  
  "Spotify": {
    title:"Science of Sound",
    client:"Spotify",
    category:"Animation",
    pageUrl:"/spotify",
    imageUrl:"img/homepage/MariaChimishkyan-Spotify.gif",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Spotify.jpg",
	rolloverColor:"#9885b6",
    	headline:"Part of a campaign for Spotify Premium with a focus on delivering music in its purest form. Devices for listening to music appear crystal clear, welcoming the viewer into their inner workings.",
		projectName:"Science of Sound",
		articleLink:"",
		discipline:"Animation",
		contributorRole:"Creative Direction",
		contributorName:"Byte",
		contributorLink:"https://bytemissioncontrol.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },   
    
  
  "TheBaffler": {
    title:"Consolation Prizes",
    client:"The Baffler",
    category:"Illustration",
    pageUrl:"/the-baffler",
    imageUrl:"img/homepage/MariaChimishkyan-TheBaffler.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-TheBaffler.png",
	rolloverColor:"#687ff1",
    	headline:"Depicting how the lowering of prices for things such as consumer electronics hasn’t solved the issues of inequality or quality of life as was promised.",
		projectName:"Consolation Prizes",
		articleLink:"https://thebaffler.com/salvos/consolation-prizes-pareene",
		discipline:"Illustration",
		contributorRole:"Art Direction",
		contributorName:"Lindsay Ballant",
		contributorLink:"http://www.lindsayballant.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },  
  
   "TheVergeOfflineActivities": {
    title:"Offline Activities",
    client:"The Verge",
    category:"Illustration",
    pageUrl:"/the-verge-offline-activities",
    imageUrl:"img/homepage/MariaChimishkyan-TheVerge.jpg",
    altDescription:"",
    thumbnailUrl:"",
	rolloverColor:"#363731",
    	headline:"Two spreads with illustrations spotlighting technology, apps, hardware, and trends of the past. Part of a zine celebrating The Verge's 10th year anniversary.",
		projectName:"Offline Activities",
		articleLink:"",
		discipline:"Illustration",
		contributorRole:"Creative Director",
		contributorName:"Elana Schlenker",
		contributorLink:"https://elanaschlenker.com/",
		
		contributorRole1:"Art Direction",
		contributorName1:"Jordi Ng",
		contributorLink1:"https://awpoop.com/"
  },  
  
      

  "WSJ": {
    title:"Fewer Choices for Shoppers this Season",
    client:"The Wall Street Journal",
    category:"Illustration",
    pageUrl:"/wsj",
    imageUrl:"img/homepage/MariaChimishkyan-WallStreetJournal.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-wsj.jpg",
	rolloverColor:"#4460b9",
    	headline:"Retailers are starting to provide customers with less options for their products, based off of research that shows too many choices can overwhelm buyers. ",
		projectName:"Fewer Choices for Shoppers this Season",
		articleLink:"",
		discipline:"Designer",
		contributorRole:"Art Direction",
		contributorName:"Lynne Carty",
		contributorLink:"http://lynnecarty.info/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  }, 

  
   "Wired": {
    title:"Save the Metaverse",
    client:"Wired",
    category:"Illustration",
    pageUrl:"/wired",
    imageUrl:"img/homepage/MariaChimishkyan-Wired-SaveTheMetaverse.jpg",
    altDescription:"",
    thumbnailUrl:"img/project-index/MariaChimishkyan-Wired-SaveTheMetaverse.jpg",
	rolloverColor:"#22CB71",
    	headline:"An illustration for Wired Magazine around the ethics of the metaverse and potential it holds in its nascent stage. Can the people building it now avoid repeating the mistakes of the past?",
		projectName:"Save the Metaverse",
		articleLink:"",
		discipline:"Designer",
		contributorRole:"Art Direction",
		contributorName:"Anjali Nair",
		contributorLink:"https://anjali-nair.com/",
		
		contributorRole1:"",
		contributorName1:"",
		contributorLink1:""
  },      
  
  "YoungGuns": {
    title:"Young Guns 15",
    client:"ADC",
    category:"Visual Identity, Year 15",
    pageUrl:"/youngguns",
    imageUrl:"img/homepage/MariaChimishkyan-YoungGuns-1.jpg",
    altDescription:"Identity, animations, physical award and printed collateral.",
    thumbnailUrl:"img/project-index/MariaChimishkyan-YoungGuns.jpg",
    rolloverColor:"#E5754F",
    shape: "sphere-cube",
    	headline:"Visual identity for Young Guns 15. Visual identity for the 15th iteration of Young Guns, an international award recognizing emerging creative talent. The system was built around forms that feel caught mid-transformation — not quite settled, not quite arrived.",
		projectName:"Young Guns 15",
		articleLink:"",
		discipline:"Senior Designer",	
		contributorRole:"Studio",
		contributorName:"RoAndCo Studio",
		contributorLink:"http://www.roandcostudio.com/#0",
		
		contributorRole1:"Creative Direction",
		contributorName1:"Roanne Adams",
		contributorLink1:""
  },
  

  "FigmaVersionControl": {
    title: "Version Control",
    client: "Figma",
    category: "Art Direction",
    pageUrl: "", imageUrl: "", altDescription: "", thumbnailUrl: "", rolloverColor: "",
    headline: "", projectName: "Version Control", articleLink: "", discipline: "Art Direction",
    contributorRole: "", contributorName: "", contributorLink: "",
    contributorRole1: "", contributorName1: "", contributorLink1: "",
    credits: "",
    imageMakerName: "Antonio Carrau",
    imageMakerLink: "https://antoniocarrau.com/",
    mediaType: "image",
    src: "img/art-direction/figma-VersionControl-AntonioCarrau.png",
  },

  "FigmaSoftwareIsCultureSwag": {
    title: "Software is Culture Swag Campaign",
    client: "Figma",
    category: "Art Direction",
    pageUrl: "", imageUrl: "", altDescription: "", thumbnailUrl: "", rolloverColor: "",
    headline: "", projectName: "Software is Culture Swag Campaign", articleLink: "", discipline: "Art Direction",
    contributorRole: "", contributorName: "", contributorLink: "",
    contributorRole1: "", contributorName1: "", contributorLink1: "",
    credits: "",
    imageMakerName: "Max Guther",
    imageMakerLink: "https://www.maxguther.de/",
    mediaType: "image",
    src: "img/art-direction/figma-SoftwareIsCultureSwag-MaxGuther-Clothesline.jpg",
  },

  "FigmaPatternLibrary": {
    title:'"The making of the Figma Pattern Library"',
    client: "Figma",
    category: "Art Direction",
    pageUrl: "", imageUrl: "", altDescription: "", thumbnailUrl: "", rolloverColor: "",
    headline: "", projectName: "Pattern Library", articleLink: "", discipline: "Art Direction",
    contributorRole: "", contributorName: "", contributorLink: "",
    contributorRole1: "", contributorName1: "", contributorLink1: "",
    credits: "",
    imageMakerName: "Julia Schimautz",
    imageMakerLink: "https://juliaschimautz.com/",
    mediaType: "video",
    src: "img/art-direction/figma-JuliaSchimautz-FigmaPatternLibrary.mp4",
  },

  "FigmaForZines": {
    title: "",
    client: "Figma",
    category: "Art Direction",
    pageUrl: "", imageUrl: "", altDescription: "", thumbnailUrl: "", rolloverColor: "",
    headline: "", projectName: "Figma for Zines", articleLink: "", discipline: "Art Direction",
    contributorRole: "", contributorName: "", contributorLink: "",
    contributorRole1: "", contributorName1: "", contributorLink1: "",
    credits: "",
    imageMakerName: "Thomas Colligan",
    imageMakerLink: "https://thomascolligan.com/",
    mediaType: "image",
    src: "img/art-direction/figma-ThomasColligan-FigmaforZines.png",
  },

  "FigmaForksPlus": {
    title: '"Meet the maker: Kelsey Fairhurst’s irresistibly bold flatware"',
    client: "Figma",
    category: "Art Direction",
    pageUrl: "", imageUrl: "", altDescription: "", thumbnailUrl: "", rolloverColor: "",
    headline: "", projectName: "Forks+", articleLink: "", discipline: "Art Direction",
    contributorRole: "", contributorName: "", contributorLink: "",
    contributorRole1: "", contributorName1: "", contributorLink1: "",
    credits: "",
    imageMakerName: "Luca Venter",
    imageMakerLink: "https://lucaventer.com/",
    mediaType: "image",
    src: "img/art-direction/figma-LucaVenter-ForksPlus.png",
  },

  "FigmaPrompt": {
    title: "The Prompt",
    client: "Figma",
    category: "Art Direction",
    pageUrl: "",
    imageUrl: "",
    altDescription: "",
    thumbnailUrl: "",
    rolloverColor: "",
    headline: "",
    projectName: "The Prompt",
    articleLink: "",
    discipline: "Art Direction",
    contributorRole: "",
    contributorName: "",
    contributorLink: "",
    contributorRole1: "",
    contributorName1: "",
    contributorLink1: "",
    credits: `Created by Story and Brand Studios. Design by <a href="https://chloescheffe.github.io/">Chloe Scheffe</a>. Contributors include Alia Fite, Amber Bravo, <a href="https://substack.com/@carly"> Carly Ayres</a>, <a href="https://cargocollective.com/jeffersoncheng">Jefferson Cheng</a>, and <a href="https://www.instagram.com/jxie03/">Jenny Xie</a>. Illustrations: <a href="https://www.instagram.com/jiyungleee/">Jiyung Lee</a>, <a href="https://www.kyleplatts.com/">Kyle Platts</a>, <a href="https://lenaweber.com/">Lena Weber</a>, <a href="https://www.thomas-merceron.com/">Thomas Merceron</a>. Photos: <a href="https://actualsource.work/">Actual Source</a>.`,
    imageMakerName: "Photographer Name",
    imageMakerLink: "https://example.com",
    images: Array.from({ length: 22 }, (_, i) => `img/art-direction/figma-prompt-MariaChimishkyan-${i}.jpg`),
  },

  "FigmaPractice": {
    title: "Practice",
    client: "Figma",
    category: "Art Direction",
    pageUrl: "",
    imageUrl: "",
    altDescription: "",
    thumbnailUrl: "",
    rolloverColor: "",
    headline: "",
    projectName: "Practice",
    articleLink: "",
    discipline: "Art Direction",
    contributorRole: "",
    contributorName: "",
    contributorLink: "",
    contributorRole1: "",
    contributorName1: "",
    contributorLink1: "",
    credits: `Created by Story and Brand Studios in collaboration with <a href="https://othermeans.us/">Other Means</a>. Contributors include Alex Praeger, Alia Fite, Amber Bravo, <a href="https://substack.com/@carly">Carly Ayres</a>, <a href="https://cargocollective.com/jeffersoncheng">Jefferson Cheng</a>, and <a href="https://www.instagram.com/jxie03/">Jenny Xie</a>. Lettering, font, and graphics by <a href="https://kiatas.me/">Kia Tasbihgou</a>. Photos: <a href="https://www.davidlaspina.com/">David La Spina</a>.`,
    imageMakerName: "Photographer Name",
    imageMakerLink: "https://example.com",
    images: Array.from({ length: 29 }, (_, i) => `img/art-direction/figma-practice-MariaChimishkyan-${i}.jpg`),
  },

}

export default ProjectModel;
